import { render } from "./AuthorizedClients.vue?vue&type=template&id=1a6c22aa&scoped=true"
import script from "./AuthorizedClients.vue?vue&type=script&lang=js"
export * from "./AuthorizedClients.vue?vue&type=script&lang=js"

import "./AuthorizedClients.vue?vue&type=style&index=0&id=1a6c22aa&scoped=true&lang=css"

import exportComponent from "/home/garyblake/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6c22aa"]])

export default __exports__